import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

interface IExportTemplateListItemEntity {
	id: number;
	code: string;
	label: string;
	isActive: boolean;
	description: string;
	projectId: number;
	metadataId: number;
	tags: OrderedSet<AppTagItemEntity>;
	updateDate: string | Date;
	updatedBy: string;
	creationDate: string | Date;
	createdBy: string;
	updatedByAvatar: AvatarEntity | null;
	createdByAvatar: AvatarEntity | null;
	pictogramUrl: string;
	connectorLabel: string;
	connectorType: string;
	outputType: string;
	iconId: number;
}

const entityDefaults: IExportTemplateListItemEntity = {
	id: -1,
	label: '',
	code: '',
	description: '',
	projectId: -1,
	metadataId: -1,
	tags: OrderedSet(),
	updateDate: '',
	updatedBy: '',
	creationDate: '',
	createdBy: '',
	isActive: false,
	updatedByAvatar: null,
	createdByAvatar: null,
	pictogramUrl: '',
	connectorLabel: '',
	connectorType: '',
	outputType: '',
	iconId: -1,
};

export class ExportTemplateListItemEntity
	implements IExportTemplateListItemEntity
{
	private [immerable] = true;
	public id = entityDefaults.id;
	public code = entityDefaults.code;
	public description = entityDefaults.description;
	public projectId = entityDefaults.projectId;
	public metadataId = entityDefaults.metadataId;
	public label = entityDefaults.label;
	public tags = entityDefaults.tags;
	public updateDate = entityDefaults.updateDate;
	public updatedBy = entityDefaults.updatedBy;
	public creationDate = entityDefaults.creationDate;
	public createdBy = entityDefaults.createdBy;
	public isActive = entityDefaults.isActive;
	public updatedByAvatar = entityDefaults.updatedByAvatar;
	public createdByAvatar = entityDefaults.createdByAvatar;
	public pictogramUrl = entityDefaults.pictogramUrl;
	public connectorLabel = entityDefaults.connectorLabel;
	public connectorType = entityDefaults.connectorType;
	public outputType = entityDefaults.outputType;
	public iconId = entityDefaults.iconId;

	public static build(
		params: Partial<IExportTemplateListItemEntity> = {}
	): ExportTemplateListItemEntity {
		const entity = new ExportTemplateListItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.code = params.code ?? entityDefaults.code;
		entity.description = params.description ?? entityDefaults.description;
		entity.label = params.label ?? entityDefaults.label;
		entity.projectId = params.projectId ?? entityDefaults.projectId;
		entity.metadataId = params.metadataId ?? entityDefaults.metadataId;
		entity.tags = params.tags ?? entityDefaults.tags;
		entity.updateDate = params.updateDate ?? entityDefaults.updateDate;
		entity.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		entity.creationDate = params.creationDate ?? entityDefaults.creationDate;
		entity.createdBy = params.createdBy ?? entityDefaults.createdBy;
		entity.isActive = params.isActive ?? entityDefaults.isActive;
		entity.createdByAvatar =
			params.createdByAvatar ?? entityDefaults.createdByAvatar;
		entity.pictogramUrl = params.pictogramUrl ?? entityDefaults.pictogramUrl;
		entity.connectorLabel =
			params.connectorLabel ?? entityDefaults.connectorLabel;
		entity.connectorType = params.connectorType ?? entityDefaults.connectorType;
		entity.outputType = params.outputType ?? entityDefaults.outputType;
		entity.iconId = params.iconId ?? entityDefaults.iconId;
		if (params.updatedBy) {
			entity.updatedByAvatar = AvatarEntity.build(params.updatedBy);
		}
		if (params.createdBy) {
			entity.createdByAvatar = AvatarEntity.build(params.createdBy);
		}
		return entity;
	}
}
